export const URLs = {
    MAILCHIMP_FORM: "https://mycopilot.us10.list-manage.com/subscribe?u=241faa8632901abf0f0fea122&id=375c85b106",
    // PLAYSTORE_BETA_INVITE: "https://play.google.com/apps/testing/ai.mycopilot.beta",
    PLAYSTORE_BETA_INVITE: "https://play.google.com/store/apps/details?id=ai.mycopilot.beta&hl=en-US&ah=hwbzlBhGB0wulBfY3UMVFOkNJD4&pli=1",
    STRIPE_PAYMENT_EAP: "https://buy.stripe.com/4gw8yY38yfHwdgceUV",
    STRIPE_PAYMENT_PREMIUM: "https://buy.stripe.com/28og1q9wW1QGgso6oq",
    FEEDBACK_URL: "https://feedback.mycopilot.ai",
    BOOK_A_DEMO: "https://aventido.com",

    DSA_RECOMMENDATION_GUIDE: "https://hubs.li/Q02N2ZZD0",

    home: '/#home',
    pricing: '/pricing',
    earlyAccess: '/early-access',
    students: '/students',
    about: '/about',
    team: '/team',
    support: '/support',
    contact: '/contact',
    adhd: '/adhd',

}